export const TipoDatoCalculado = {
  Datos: 1,
  Secuencia: 2,
  SecuenciaResultado: 3,
  Valor: 4,
  Constante: 5,
  DatosAutomaticos: 6,
  ContenidoTabla: 7,
};